import { Navigate, type RouteObject } from 'react-router';

import { workspaceMethods } from '@synapex/shared2/entities';
import { workspacePath } from '@synapex/shared2/gateway-rest-api';

import { ReferralPage } from '@/true-fsd/layout/Referral';
import { queryClient } from '../../providers/queryClient';
import { WorkspaceLayout } from '@/true-fsd/layout/Workspace';
import { referralManyLoader } from '@/true-fsd/data/referral/router/loader';
import { OutletContextTypeGuard } from '../guards';
import { analytics } from './children/children/analytics';
import { settings } from './children/children/settings';
import { useDefaultWorkspace } from '@/true-fsd/data/advertiser-account/react-query';
import { isWorkspaceOutletContext } from '@/true-fsd/data/advertiser-account';
import { HistoryTreeWrite } from '../history-store/HistoryTreeWrite';

// eslint-disable-next-line react-refresh/only-export-components
const ToDefaultWorkspace = () => {
  const workspace = useDefaultWorkspace(null);

  return (
    <Navigate
      to={workspace ? workspacePath(workspaceMethods.getWd(workspace)) : '/'}
      replace
    />
  );
};

export const workspace = {
  path: 'workspace',
  children: [
    {
      path: ':workspace_type/:workspace_id',
      element: <OutletContextTypeGuard typeGuard={isWorkspaceOutletContext} />,
      children: [
        {
          Component: WorkspaceLayout,
          children: [
            analytics,
            settings,
            {
              path: 'referral',
              loader: referralManyLoader(queryClient),
              element: (
                <HistoryTreeWrite>
                  <ReferralPage />
                </HistoryTreeWrite>
              ),
            },
            {
              index: true,
              element: <Navigate to="analytics" />,
            },
            {
              path: '*',
              element: <Navigate to=".." />,
            },
          ],
        },
      ],
    },
    {
      index: true,
      Component: ToDefaultWorkspace,
    },
    {
      path: '*',
      Component: ToDefaultWorkspace,
    },
  ],
} satisfies RouteObject;
